import * as actionTypes from './actionTypes'

export const myTask = (state = {
  data: null,
  isFetching: true,
  error: null,
  didInvalidate: false,
}, action) => {
  switch (action.type) {
    case actionTypes.MY_TASK_REQUEST:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
        error: null,
      };
    case actionTypes.MY_TASK_RECEIVE:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        didInvalidate: false,
        error: null,
      };
    case actionTypes.MY_TASK_ERROR:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        error: action.error,
      };
    case actionTypes.MY_TASK_INVALIDATE:
      return {
        ...state,
        didInvalidate: true,
        error: null,
      };
    case actionTypes.MY_TASK_UPDATE_REQUEST:
      return {
        ...state,
        isFetchingUpdate: true,
        errorUpdate: null,
      };
    case actionTypes.MY_TASK_UPDATE_RECEIVE:
      return {
        ...state,
        data: action.data,
        isFetchingUpdate: false,
        errorUpdate: null,
      };
    case actionTypes.MY_TASK_UPDATE_ERROR:
      return {
        ...state,
        isFetchingUpdate: false,
        errorUpdate: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/myTask/reducers.js